import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps, State } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { StructureHomeActions, structureHomeActions } from './structure-home.actions'
import { genericError } from 'src/utils/notifications.utils'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

interface Action$ extends ActionsObservable<StructureHomeActions> {}
interface State$ extends StateObservable<State> {}

const getCompanyCredits = (dsService: DSService) => (p: { [startFetch]: string; token: string }) =>
  from(
    dsService.getCompaniesCredits(p.token).map(resOpt =>
      pipe(
        resOpt,
        O.fold(
          () => {
            genericError()
            return structureHomeActions.GetCompanyCreditsFailed({
              [stopFetch]: p[startFetch]
            })
          },
          res =>
            structureHomeActions.GetCompanyCreditsSuccess({
              [stopFetch]: p[startFetch],
              credits: res.result
            })
        )
      )
    )
  )

export const getCompanyCreditsEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(structureHomeActions.is.GetCompanyCredits),
    mergeMap(getCompanyCredits(deps.dsService))
  )

export const structureHomeEpics = combineEpics(getCompanyCreditsEpic)



// WEBPACK FOOTER //
// ./src/home/structure/structure-home.epics.ts